import { get } from '../../../utils/api';
import { withUnauthorizedToken } from '../../../utils/auth';

export default {
  getRestaurants: () => get({ url: 'restaurant/list' }),
  getRestaurantAddress: params => get({ url: 'restaurant/find', data: params }),
  getCartStopList: restaurant_id =>
    get({ url: 'cart/stop-list', data: withUnauthorizedToken({ restaurant_id }) }),
};
